module.exports = __webpack_public_path__ + "static/media/video-belleza-2020.02924e24.mp4";